import {Component} from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";
import { CxoneOrderManagementService } from "../../../services/cxone-order-management.service";
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import { MatTooltipModule } from "@angular/material/tooltip";

@Component({
    selector: 'div.text-truncate',
    standalone: true,
    imports: [MatTooltipModule],
    template: `
        <div [style.overflow]="'hidden'" [style.textOverflow]="'ellipsis'" class="d-flex h-100" 
        [matTooltip]="isTextHasEllipsis(textStatus) ? cvLocalizationService.getCachedText('Order_Management', this.statusMessageLocalization[status?.name] || status?.name, status?.name) : undefined"
        matTooltipPosition="after" matTooltipClass="custom-tooltip-dropdown">
          <i class="icon-status">
            <svg class="icon-16 fill-iconDefault">
              <use [attr.href]="status.iconPath"></use>
            </svg>
          </i>
          <p #textStatus class="status-name text-truncate">
            {{this.cvLocalizationService.getCachedText("Order_Management", this.statusMessageLocalization[status?.name] || status?.name, status?.name)}}
          </p>
        </div>
    `,
    styles: [
        `
            .icon-status {
                padding-right: 8px;
                padding-left: 6px;
            }

            .status-name {
                font-family: "OpenSans";
                font-size: 13px;
                font-weight: 400;
                margin: 0;
                padding-top: 2px;
            }

            ::ng-deep .custom-tooltip-dropdown {
                background-color: white;
                border: 1px solid #D2D8DB;
                -webkit-box-shadow: -2px 3px 39px 6px rgba(210, 216, 219, 0.27);
                -moz-box-shadow: -2px 3px 39px 6px rgba(210, 216, 219, 0.27);
                box-shadow: -2px 3px 39px 6px rgba(210, 216, 219, 0.27);
                max-width: 310px;
                border-radius: 0 !important;
                color: #333333 !important;
                font-family: 'Open Sans' !important; 
                font-weight: 400 !important;
                font-size: 13px !important;
                overflow-wrap: break-word;
            }

            ::ng-deep .mdc-tooltip__surface {
                font-family: 'Open Sans' !important;
                background-color: white !important;
                padding: 8px;
                color: #333333 !important;
            }
        `
    ]
})
export class StatusCellEditRenderer implements ICellRendererAngularComp {

    status = null;

    statusMessageLocalization = {
        "In Transit": "In_Transit",
        "Ready for Pickup": "Ready_For_Pickup"
    };

    constructor(
        public cvLocalizationService: CVLocalizationService,
        private orderManagementService: CxoneOrderManagementService
    ) {
        this.cvLocalizationService.GetSection("Order_Management");
    }

    public params!: ICellRendererParams;

    agInit(params: ICellRendererParams): void {
        this.params = params;
        this.status = this.orderManagementService.getStatusById(params.value);
    }

    refresh() {
        return false
    }

    isTextHasEllipsis(element: HTMLElement): boolean {
        return element.scrollWidth > element.clientWidth;
    }
}
